import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: white;
  border-radius: 24px;
  padding: 4px;
  gap: 4px;
`;

const ToggleButton = styled.button<{ active: boolean }>`
  padding: 3px 10px;
  border: none;
  border-radius: 20px;
  min-width: 82px;
  font-family: Oswald, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  background-color: ${(props) =>
    props.active ? props.theme.colors['terra-cotta'] : 'transparent'};
  color: ${(props) =>
    props.active ? 'white' : props.theme.colors['cool-grey']};

  &:hover {
    background-color: ${(props) =>
      props.active
        ? props.theme.colors['terra-cotta']
        : props.theme.colors['cool-grey']};
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

type CategoryToggleProps = {
  value: string;
  onChange: (value: string) => void;
};

const CategoryToggle = ({ value, onChange }: CategoryToggleProps) => {
  const isWine = value === '1';
  const isSpirit = value === '2';

  return (
    <ToggleContainer>
      <ToggleButton
        active={isWine}
        onClick={() => onChange('1')}
        aria-pressed={isWine}
      >
        {I18n.t('globalView.filters.options.categories.wine')}
      </ToggleButton>
      <ToggleButton
        active={isSpirit}
        onClick={() => onChange('2')}
        aria-pressed={isSpirit}
      >
        {I18n.t('globalView.filters.options.categories.spirit')}
      </ToggleButton>
    </ToggleContainer>
  );
};

export default CategoryToggle;
